import script from "./kpi-library.vue?vue&type=script&setup=true&lang=js"
export * from "./kpi-library.vue?vue&type=script&setup=true&lang=js"

import "./kpi-library.vue?vue&type=style&index=0&id=337fc3b4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-337fc3b4"]])

export default __exports__